import { SecondaryHeader, SecondaryHeaderInfo } from "olive-react-myoneui"

export default function Dashboard() {
  return (
    <>
      <div className='content-wrapper'>
        <SecondaryHeader>
          <SecondaryHeaderInfo SecondaryHeaderTitle='Dashboard' />
        </SecondaryHeader>
        <div className='content-block'>
          <h2>Welcome to Examally.</h2>
        </div>
      </div>
    </>
  )
}
